<template>
  <b-form-group :label="properties.label">
    <b-input
      v-model="propertyValue"
      :min="minValue"
      size="sm"
      :type="properties.type ? properties.type : 'text'"
    ></b-input>
  </b-form-group>
</template>

<script>
export default {
  name: "TextInputPropertyType",
  props: ["properties", "property", "value"],
  data() {
    return {
      minValue: undefined
    }},
  mounted() {
    if(this.properties.minValue !== undefined)
    {
      this.minValue = this.properties.minValue.toString();
    }
  },
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        let wrapperNewValue = newValue;
        if (this.properties.type == "number") {
          if (this.properties.minValue !== undefined && wrapperNewValue < this.properties.minValue) {
            wrapperNewValue = this.properties.minValue;
          }
          else {
            wrapperNewValue = parseFloat(newValue);
          }

        }
        this.$emit("update-value", this.property, wrapperNewValue);
      }
    }
  }
};
</script>
